import * as types from "../actions/actionsTypes";

let initialState = {
  brandsList: [],
  showLinearBrands: 'grid'
};

const brandsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_BRANDS:
      return {
        ...state,
        brandsList: action.data,
      };

    case types.RESET_BRANDS:
      return {
        ...state,
        brandsList: [],
      };
    
    case types.SHOW_LINEAR_BRANDS:
      return {
        ...state,
        showLinearBrands: action.data,
      };


    default:
      return state;
  }
};

export default brandsReducer;
